import { DatePicker, Flex, Typography } from "antd";
import dayjs from "dayjs";
import { t } from "i18next";
import { forwardRef, useImperativeHandle, useState } from "react";

const { Title, Text } = Typography;

interface TimeSelectorProps {
  curTime: number;
  curTimeTip?: string;
  finalTimeTip?: string;
  changeTip?: string;
}

export interface TimeSelectorRef {
  getFinalTime: () => number;
  resetTime: () => void;
}

export const TimeSelector = forwardRef<TimeSelectorRef, TimeSelectorProps>(({ curTime, curTimeTip, finalTimeTip, changeTip }, ref) => {

  const [finalTime, setFinalTime] = useState<number>(curTime);

  useImperativeHandle(ref, () => ({
    getFinalTime: () => finalTime,
    resetTime: () => {
      setFinalTime(curTime);
    }
  }));

  return (
    <>
      <div style={{ marginBottom: 24 }}>
        <Title level={4}>
          {curTimeTip || t('common.currentTime')}: {dayjs(curTime).format("YYYY-MM-DD")}
        </Title>
      </div>

      <Flex vertical gap={16}>
        <Flex gap={6} align="center">
          <Text>{changeTip || t('common.selectTime')}:</Text>
          <DatePicker value={dayjs(finalTime)} onChange={val => {
            let newV: number = val ? val.valueOf() : curTime;
            setFinalTime(newV)
          }} allowClear={false} />
        </Flex>

        {finalTimeTip && <div>
          <Text strong>{finalTimeTip}:</Text>
          <div style={{ marginTop: 8, fontSize: 16 }}>
            {dayjs(finalTime).format("YYYY-MM-DD")}
          </div>
        </div>}
      </Flex>
    </>
  );
});

TimeSelector.displayName = "TimeSelector";